import React from "react";
import { mergeStyles } from "@fluentui/merge-styles";
import { Spinner } from "@fluentui/react-components";

const wrapperClass = mergeStyles({
  position: "fixed",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "white",
  zIndex: 9999,
});

const labelClass = mergeStyles({
  fontSize: "12px",
});

const spinnerContentClass = mergeStyles({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 8,
});

type Props = {
  title: string;
};

const FullPageLoader: React.FC<Props> = (props) => {
  const { title } = props;

  return (
    <div className={wrapperClass}>
      <div className={spinnerContentClass}>
        <Spinner size="medium" />
        <span className={labelClass}>{title}</span>
      </div>
    </div>
  );
};

export default FullPageLoader;
